import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setCampaignName,
  setCampaignDescription,
  setCampaignType,
  setComplaiceStatus,
  setCampaignABTestEnabled,
  setCampaignABTestChecked,
} from "ReduxStore/Slices/campaignSlice";
import CampaignABTest from "./CampaignABTest";

export default function CampaignInfo() {
  const { campaignName, campaignType, campaignDescription, campaignABTestEnabled, campaignABTestChecked, campaignEditMode, campaignId, campaignViewMode } = useSelector(
    (state) => state.campaignSetter
  );
  const dispatch = useDispatch();
  const campaignNameRef = useRef();
  const campaignDescriptionRef = useRef();
  const campaignTypeRef = useRef();
  const campaignABTestCheck = useRef();

  useEffect(() => {
    campaignNameRef.current.value = campaignName;
    campaignDescriptionRef.current.value = campaignDescription;
    campaignTypeRef.current.value = campaignType;
    if (campaignABTestEnabled) {
      campaignABTestCheck.current.checked = campaignABTestChecked;
    }
    campaignType === "email" ? dispatch(setCampaignABTestEnabled(true)) : dispatch(setCampaignABTestEnabled(false))
  }, [campaignName, campaignDescription, campaignType, campaignABTestEnabled]);

  useEffect(()=>{
    if(role=='publisher')
      dispatch(setCampaignType('publishedContent'));
  },[])

  const { role } = useSelector(
    (state) => state.userSetter
  );

  return (
    <>
      <div
        className="camp_name_desc"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <div className="campaign_name">
          <label className="large">Campaign Name</label>
          <input
            type="text"
            id="campaign_name_camp"
            className="kwDesign"
            onChange={(e) => {
              dispatch(setCampaignName(e.target.value));
              dispatch(setComplaiceStatus("Editing"));
            }}
            ref={campaignNameRef}
            required
            disabled={campaignViewMode}
          />
        </div>
        <div style={{ marginLeft: 50 }}>
          <label className="large" >
            Select Type
          </label>
          <div>
            <select
              onChange={(e) => {
                dispatch(setCampaignType(e.target.value));
                dispatch(setComplaiceStatus("Editing"));
              }}
              id="selectSubscribtion"
              className="kwDesign2 w486"
              ref={campaignTypeRef}
              disabled={campaignViewMode}
            >

              {role !='publisher'&&<option value="">Select</option>}
              <option value="publishedContent">Web Page</option>
              {role !='publisher'&&<option value="email">Email</option>}
            </select>
          </div>
        </div>
        {campaignABTestEnabled && <div className="d-flex justify-content-center align-items-center ml-5">
          <div className="kwCheckboxw20" style={{ marginTop: "35px" }}>
            <input
              onChange={(e) => {
                dispatch(setCampaignABTestChecked(e.target.checked))
              }}
              type="checkbox"
              id="checkbox1"
              ref={campaignABTestCheck}
              disabled={(campaignEditMode || campaignId !== "") || campaignViewMode ? true : false}
            />
            <label
              id="checkID"
              for="checkbox1"
              className="kwCheckboxText"
            >
              A/B Test
            </label>
          </div>
        </div>}
      </div>
      {
        (campaignABTestChecked && campaignABTestEnabled) && <CampaignABTest />
      }

      <div className="campaign_description">
        <label className="large">Description</label>

        <textarea
          id="description"
          type="text"
          className="csTextarea"
          ref={campaignDescriptionRef}
          onChange={(e) => {
            dispatch(setCampaignDescription(e.target.value));
            dispatch(setComplaiceStatus("Editing"));
          }}
          required
          disabled={campaignViewMode}
        ></textarea>
      </div>
    </>
  );
}
